import { render } from "./krCopyValue.vue?vue&type=template&id=513f2c74&scoped=true"
import script from "./krCopyValue.vue?vue&type=script&lang=js"
export * from "./krCopyValue.vue?vue&type=script&lang=js"

import "./krCopyValue.vue?vue&type=style&index=0&id=513f2c74&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513f2c74"]])

export default __exports__